/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../root'
import DateCell from './DateCell'

interface TableDateTimeCellProps {
  val?: string | number | Date | null
  className?: string
  includeTime?: boolean
}

const TableDateTimeCell: React.FC<TableDateTimeCellProps> = ({ val, className, includeTime = false }) => {
  const context = useServiceContext()
  const translate = context.service.filter.translate

  const combinedClassName = `table-datetime-cell${className ? ' ' + className : ''}`

  return val ? (
    <span className={combinedClassName}>
      <span className="date-part">
        <DateCell val={val} includeTime={includeTime} />
      </span>
    </span>
  ) : (
    <span className={combinedClassName}>{translate('NOT_AVAILABLE')}</span>
  )
}

export default TableDateTimeCell
